import React, {Component, PropTypes} from 'react'
import styles from './categories.scss'
import {catIdToString} from 'lib/i18n'

export const CategoryDom = ({text}) => {
	return <span className={styles.category} children={text}/>
}
CategoryDom.propTypes = {
	text: PropTypes.string,
}

export default class Category extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
	}

	render() {
		const {id} = this.props
		const category = catIdToString(id)
		return (
			<CategoryDom text={category}/>
		)
	}
}



// WEBPACK FOOTER //
// ./components/categories.jsx